import { formatPrice } from "@api/utils";
import { AcquisitionOrderIcon } from "@components/backoffice/icons";
import { getDisplayVal } from "@config";
import { AcquisitionRoutes, BackOfficeRoutes } from "@routes/urls";
import { Truncate } from "@components/Truncate";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Grid, Item, List } from "semantic-ui-react";
import _get from "lodash/get";
import { renderSubtitle } from "@modules/Document/utils";

export default class OrderListEntry extends Component {
  renderLeftColumn = (order, record) => {
    return (
      <>
        <Item.Description>
          <label>Status </label>
          {getDisplayVal("ACQ_ORDERS.statuses", order.metadata.status)}
        </Item.Description>
      </>
    );
  };

  renderOrderLine = (orderLine, index) => {
    const documentPid = orderLine.document_pid;
    const patronPid = orderLine.patron_pid;
    const medium = orderLine.medium;
    const documentLink = (
      <Link to={BackOfficeRoutes.documentDetailsFor(documentPid)}>
        <code>{documentPid}</code>
      </Link>
    );
    const totalPrice = formatPrice(orderLine.total_price);
    return (
      <List.Item
        as="li"
        key={documentPid}
        value={`${orderLine.copies_ordered}x`}
      >
        {documentLink} - {medium}
        {patronPid && (
          <>
            {" "}
            - Patron{" "}
            {patronPid > 0 ? (
              <Link to={BackOfficeRoutes.patronDetailsFor(patronPid)}>
                <code>{patronPid}</code>
              </Link>
            ) : (
              <>anonymous</>
            )}
          </>
        )}{" "}
        - <em>{totalPrice}</em>
      </List.Item>
    );
  };

  renderMiddleColumn = (order) => {
    const { renderMiddleColumn } = this.props;
    if (renderMiddleColumn) {
      return renderMiddleColumn(order);
    }
    return <List as="ol"> </List>;
  };

  renderRightColumn = (order) => {
    const { renderRightColumn } = this.props;
    if (renderRightColumn) {
      return renderRightColumn(order);
    }
    const { received_date: receivedDate, payment } = order.metadata;
    return (
      <List verticalAlign="middle" className="document-circulation">
        {payment && <List.Item> </List.Item>}
        {receivedDate && (
          <List.Item>
            <List.Content floated="right">
              <strong>{receivedDate}</strong>
            </List.Content>
            <List.Content>received</List.Content>
          </List.Item>
        )}
      </List>
    );
  };

  render() {
    const { record } = this.props;

    const docTitle =
      _get(record, "metadata.document.title") ||
      _get(record, "metadata.resolved_order_lines[0].document.title") ||
      null;

    const subtitle = renderSubtitle(
      _get(record, "metadata.document.alternative_titles") ||
        _get(
          record,
          "metadata.resolved_order_lines[0].document.alternative_titles"
        )
    );

    return (
      <Item>
        <Item.Content>
          <Item.Header
            as={Link}
            to={AcquisitionRoutes.orderDetailsFor(record.metadata.pid)}
            data-test={`navigate-${record.metadata.pid}`}
          >
            {/* Display PID if no title is available */}
            <Truncate lines={2} width="500px">
              <AcquisitionOrderIcon />
              {docTitle ? docTitle : `Order #${record.metadata.pid}`}
            </Truncate>
          </Item.Header>
          {subtitle && <Item.Meta>{subtitle}</Item.Meta>}
          <Grid highlight={3}>
            <Grid.Column computer={5} largeScreen={5}>
              {this.renderLeftColumn(record)}
            </Grid.Column>
            <Grid.Column computer={5} largeScreen={5}>
              {this.renderMiddleColumn(record)}
            </Grid.Column>
            <Grid.Column width={1} />
            <Grid.Column computer={5} largeScreen={5}>
              {this.renderRightColumn(record)}
            </Grid.Column>
          </Grid>
        </Item.Content>
        <div className="pid-field">#{record.metadata.pid}</div>
      </Item>
    );
  }
}

OrderListEntry.propTypes = {
  record: PropTypes.object.isRequired,
  renderMiddleColumn: PropTypes.func,
  renderRightColumn: PropTypes.func,
};

OrderListEntry.defaultProps = {
  renderMiddleColumn: null,
  renderRightColumn: null,
};
